<template>
  <v-container >
    <v-layout >
      <v-container class="table-full">
        <v-layout row wrap >
          <v-flex ma-1 class="expandableContainer">
            <v-data-table
              hide-actions
              :loading="loading"
              :items="[{parentName, parentLastName, typeUser, door, carModel, carColor, plates, idcar, device, whoDelivered, whoCancelled}]"
              :height="'14vh'"
              style="max-height: 18vh;"
            >
              <template v-slot:headers>
                <tr>
                  <th>
                    Nombre
                  </th>
                  <th>
                    Apellido
                  </th>
                  <td>
                    Usuario
                  </td>
                  <td v-show="device">
                    Nombre del dispositivo
                  </td>
                  <th>
                    Puerta
                  </th>
                  <td>
                    Transporte
                  </td>
                  <th v-show="carModel != 'Taxi' && carModel != 'Caminando'">
                    Modelo
                  </th>
                  <th v-show="carModel != 'Taxi' && carModel != 'Caminando'">
                    Color
                  </th>
                  <th v-show="carModel != 'Taxi' && carModel != 'Caminando'">
                    Placas
                  </th>
                  <th>
                    Confirmado por
                  </th>
                  <th>
                    Cancelado por
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                    <td>{{ props.item.parentName}}</td>
                    <td>{{ props.item.parentLastName }}</td>
                    <td v-if="props.item.typeUser != 'EMP'">{{props.item.typeUser}}</td>
                    <td v-else>Staff</td>
                    <td v-show="device">{{ props.item.device }}</td>
                    <td>{{ props.item.door}}</td>
                    <td v-if="carModel == 'Taxi' || carModel == 'Caminando'">{{ props.item.carModel }}</td>
                    <td v-else>Auto</td>
                    <td v-show="carModel != 'Taxi' && carModel != 'Caminando'">{{ props.item.carModel }}</td>
                    <td v-show="carModel != 'Taxi' && carModel != 'Caminando'">{{ props.item.carColor }}</td>
                    <td v-show="carModel != 'Taxi' && carModel != 'Caminando'">{{ props.item.plates }}</td>
                    <td>{{ props.item.whoDelivered }}</td>
                    <td>{{ props.item.whoCancelled }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

        <!--v-on:desition="desitionDelete"-->
        <loading v-model="working.wLoading" text="Trabajando"></loading>
        <success v-model="toast.success" text="Operación Exitosa"></success>
        <error v-model="toast.failed" text="Ups ocurrió un error"></error>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import loading from "../../Dialogs/Loading";
import success from "../../Dialogs/Success";
import error from "../../Dialogs/Error";
export default {
  components: {
    loading,
    success,
    error
  },
  props: ["parentName", "parentLastName", "typeUser", "door", "carModel", "carColor", "plates", "id", "idcar", "status", "device", "whoDelivered", "whoCancelled"],
  data: () => ({
    headers: [
      {
        text: "Nombre",
        align: "left",
        value: "parentName"
      },
      {
        text: "Apellido",
        value: "lastName"
      },
      {
        text: "Usuario",
        value: "typeUser",
      },
      {
        text: "Puerta",
        value: "door"
      },
      {
        text: "Transporte",
        value: "carModel"
      },
      {
        text: "Modelo",
        value: "carModel"
      },
      {
        text: "Color",
        value: "carColor"
      },
      {
        text: "Placas",
        value: "plates"
      },
    ],
    selected: [],
    select: {
      parent: null
    },
    working: {
      wLoading: false
    },
    loading: false,
    tile: false,
    modals: {
      title: "",
      parent: false,
      import: false,
      value: false,
      LinkV: false
    },
    buttonFab: {
      fab: false,
      hidden: false
    },
    gotImages: 0,
    toast: {
      success: false,
      failed: false
    }
  }),
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped>
  .no-padding {
    padding-left: 8%;
  }
  .position-no {
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: -1;
  }

  .expandableContainer {
    border-style: solid;
    border-color: #e6e6e6;
    border-radius: 15px;
    border-width: 2px;
  }

  th,
  td {
    width: 160px;
    max-width: 160px;
    min-width: 140px;
  }
  
  /deep/ .v-datatable.v-table > tbody {
    max-height: 9vh;
    min-height: 9vh;
  }
  
</style>

